<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab" @tab-click="typeCheck">
      <el-tab-pane label="专辑管理" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option k-filter-input k-select-input">
              <el-input
                placeholder="请输入关键词"
                :size="size"
                v-model="searchForm.query"
                class="input-with-select"
                @change="doSearch"
              >
                <el-select v-model="searchForm.searchType" slot="prepend" class="select-input">
                  <el-option label="搜全部" value="0"></el-option>
                  <el-option label="搜专辑" value="1"></el-option>
                  <el-option label="搜文件夹" value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
              </el-input>
            </div>
          </div>
          <div class="k-album-content">
            <div class="k-search-component tree-wrapper">
              <div>
                <div class="tree-title" @click="allAlbum">全部专辑</div>
                <div style="margin-top: 10px; overflow: auto;">
                  <el-tree
                    ref="filter-tree"
                    class="filter-tree"
                    :data="treeData"
                    :props="defaultProps"
                    node-key="id"
                    highlight-current
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                  ></el-tree>
                </div>
              </div>
            </div>
            <div class="k-list-wrapper">
              <div class="list-toolbar">
                <div>
                  <el-button
                    :size="size"
                    type="primary"
                    icon="el-icon-plus"
                    @click="uploadSource"
                  >上传素材</el-button>
                  <el-button :size="size" v-if="addGroup==1" @click="addAlbumOpen">新建专辑</el-button>
                  <el-button :size="size" v-if="addGroup==2" @click="addFolderOpen">新建文件夹</el-button>
                  <el-button :size="size" @click="handleAll">批量操作</el-button>
                  <el-button :size="size" @click="uploadList">发布详情</el-button>
                </div>
                <div>
                  <!-- <el-button type="text" :size="size" style="margin-right:10px;">刷新</el-button> -->
                  <el-select
                    v-model="searchForm.order"
                    placeholder="请选择"
                    :size="size"
                    style="width:130px;"
                    @change="sortSource"
                  >
                    <el-option label="按名称降序" value="1"></el-option>
                    <el-option label="按名称升序" value="2"></el-option>
                    <el-option label="按更新时间降序" value="3"></el-option>
                    <el-option label="按更新时间升序" value="4"></el-option>
                    <el-option label="按创建时间降序" value="5"></el-option>
                    <el-option label="按创建时间升序" value="6"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="breadcrumb-container">
                <el-breadcrumb separator="/">
                  <el-breadcrumb-item v-for="(item,index) in tagsList" :key="index">
                    <span
                      v-if="index != tagsList.length-1"
                      @click="toTag(item)"
                      :style="{color:'#197afb',cursor:'pointer'}"
                    >{{item.name}}</span>
                    <span v-else>{{item.name}}</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="k-scroll-box">
                <div
                  class="data-empty-wrapper data-empty-block"
                  v-if="tableData.groupList.length == 0 && tableData.sourceList.length == 0"
                >
                  <img src="../../assets/images/null_data.png" class="data-empty-img" />
                  <p class="data-empty-description">暂无数据</p>
                </div>
                <template v-if="tableData.groupList.length > 0 || tableData.sourceList.length > 0">
                  <ul class="list-content">
                    <li
                      class="list-item"
                      v-if="tableData.groupList.length > 0"
                      v-for="(item, index) in tableData.groupList"
                    >
                      <template v-if="item.pid == 0">
                        <template v-if="item.img.length > 0" v-for="(itemimg,indeximg) in item.img">
                          <div
                            class="pic-box pointer"
                            @click="handleFolder(item)"
                            :style="{backgroundImage: 'url(' + itemimg + ')',backgroundSize:'cover'}"
                          ></div>
                        </template>
                        <template v-if="item.img.length == 0">
                          <div class="pic-box pointer" @click="handleFolder(item)"></div>
                        </template>
                        <div class="name-box">
                          <p :title="item.name" class="nowrap">{{item.name}}</p>
                        </div>
                        <div class="tool-box">
                          <div class="tool-box-left">
                            素材
                            <span class="num">{{item.sourceTotal}}</span>
                          </div>
                          <div class="tool-box-right">
                            <el-popover
                              popper-class="album-btn-popover"
                              placement="bottom"
                              trigger="hover"
                            >
                              <div class="btn-list">
                                <p @click="editAlbumOpen(item.id)">编辑</p>
                              </div>
                              <span class="btn" slot="reference"></span>
                            </el-popover>
                          </div>
                        </div>
                      </template>
                      <template v-if="item.pid != 0">
                        <div class="pic-item-box pointer">
                          <div class="pic-item-box-bot" @click="handleChild(item)">
                            <div class="pic-item"></div>
                            <div class="pic-item"></div>
                            <div class="pic-item"></div>
                            <div class="pic-item"></div>
                          </div>
                          <div class="pic-item-box-top" @click="handleChild(item)">
                            <template
                              v-if="item.img.length > 0"
                              v-for="(itemimg,indeximg) in item.img"
                            >
                              <div
                                class="pic-item"
                                :style="{backgroundImage: 'url(' + itemimg + ')',backgroundSize:'cover'}"
                              ></div>
                            </template>
                          </div>
                        </div>
                        <div class="name-box">
                          <p :title="item.name" class="nowrap">{{item.name}}</p>
                        </div>
                        <div class="tool-box">
                          <div class="tool-box-left">
                            素材
                            <span class="num">{{item.sourceTotal}}</span>
                          </div>
                          <div class="tool-box-right">
                            <el-popover
                              popper-class="album-btn-popover"
                              placement="bottom"
                              trigger="hover"
                            >
                              <div class="btn-list">
                                <p @click="editFolderOpen(item.id)">编辑</p>
                                <p @click="delFolder(item.id,item.sourceTotal)">删除</p>
                              </div>
                              <span class="btn" slot="reference"></span>
                            </el-popover>
                          </div>
                        </div>
                      </template>
                    </li>
                    <li
                      class="list-item"
                      v-if="tableData.sourceList.length > 0"
                      v-for="(item, index) in tableData.sourceList"
                    >
                      <div class="item">
                        <div class="pic-box">
                          <template v-if="item.top_img">
                            <div
                              class="cover"
                              @click="sourceDetail(item.id)"
                              :style="{backgroundImage: 'url(' + item.top_img + ')',backgroundSize:'cover'}"
                            >
                              <i class="video-play" v-if="item.type == 'video'"></i>
                            </div>
                          </template>
                          <template v-else>
                            <div class="cover"></div>
                          </template>
                          <p class="video-info video-size">{{item.width}}*{{item.height}}</p>
                          <template v-if="item.type == 'video'">
                            <p class="video-info video-time">{{item.times}}</p>
                          </template>
                        </div>
                        <div class="name-box">
                          <p class="nowrap fs12">{{item.name}}</p>
                          <p class="btn_detail" @click="sourceDetail(item.id)">详情</p>
                        </div>
                        <div class="tips-box">
                          <div
                            class="material-tag material-tag--blue"
                            v-if="item.is_publish == '1'"
                          >已发布</div>
                          <div
                            class="material-tag material-tag--info"
                            v-if="item.is_publish == '0'"
                          >未发布</div>
                          <!-- <div class="material-tag material-tag--warning">无消耗</div> -->
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="pagination-box">
                    <el-pagination
                      background
                      ref="pagination"
                      @current-change="handleCurrentChange"
                      :current-page="tableData.current_page | number"
                      :page-size="tableData.per_page | number"
                      layout="total, prev, pager, next, jumper"
                      :total="tableData.total | number"
                    ></el-pagination>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="素材管理" name="second">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option k-filter-input">
              <el-input
                placeholder="请输入素材名或素材ID"
                :size="size"
                v-model="searchFormSource.query"
                @change="doSearchSource"
              >
                <el-button slot="append" icon="el-icon-search" @click="doSearchSource"></el-button>
              </el-input>
            </div>
            <!-- <div class="k-filter-option">
                        <div class="k-select-area">
                            <label>素材目录:</label>
                            <el-cascader :size="size" :options="treeData" :props="cascaderProps" clearable style="width:100%;"></el-cascader>
                        </div>
            </div>-->
          </div>
          <div class="mg-filter-btnwrap">
            <div class="material_btn-box">
              <el-button icon="el-icon-plus" type="primary" :size="size" @click="uploadSource">上传素材</el-button>
              <el-button :size="size">获取账户素材</el-button>
              <el-button :size="size" @click="handelOption">批量操作</el-button>
            </div>
            <div class="batch_area" v-if="optionAll">
              <div class="check-all-box">
                <el-checkbox :size="size" style="font-size:12px;" @change="selectAll">全选</el-checkbox>
                <p class="had_check">
                  已选
                  <span>{{selectNum}}</span>个素材
                </p>
              </div>
              <div class="batch_operate">
                <el-button
                  :size="size"
                  @click="uploadLine"
                  :disabled="selectNum <= 0"
                  v-if="$parent.$parent.isAuthAction('home/v1.medias/mediaSelectBliBli')"
                >发布</el-button>
                <el-button :size="size" @click="delSelectAll" :disabled="selectNum <= 0">删除</el-button>
                <el-button type="primary" plain :size="size" @click="selectOk">完成</el-button>
              </div>
            </div>
          </div>
          <div class="property-material" style="position: relative;">
            <div
              class="data-empty-wrapper data-empty-block"
              v-if="tableDataSource.list.length <= 0"
            >
              <img src="../../assets/images/null_data.png" class="data-empty-img" />
              <p class="data-empty-description">暂无数据</p>
            </div>
            <ul class="list-content">
              <li
                class="list-item"
                v-for="(item, index) in tableDataSource.list"
                v-if="tableDataSource.list.length > 0"
              >
                <div class="item">
                  <el-checkbox
                    class="check_single"
                    v-if="optionAll"
                    v-model="item.check"
                    @change="changeCard(item)"
                  ></el-checkbox>
                  <div class="pic-box">
                    <template v-if="item.top_img">
                      <div
                        class="cover"
                        @click="sourceDetail(item.id)"
                        :style="{backgroundImage: 'url(' + item.top_img + ')',backgroundSize:'cover'}"
                      >
                        <i class="video-play" v-if="item.type == 'video'"></i>
                      </div>
                    </template>
                    <template v-else>
                      <div class="cover"></div>
                    </template>
                    <p class="video-info video-size">{{item.width}}*{{item.height}}</p>
                    <template v-if="item.type == 'video'">
                      <p class="video-info video-time">{{item.times}}</p>
                    </template>
                  </div>
                  <div class="name-box">
                    <p class="nowrap fs12">{{item.name}}</p>
                    <p class="btn_detail" @click="sourceDetail(item.id)">详情</p>
                  </div>
                  <div class="tips-box">
                    <div class="material-tag material-tag--blue" v-if="item.is_publish == '1'">已发布</div>
                    <div class="material-tag material-tag--info" v-if="item.is_publish == '0'">未发布</div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="pagination-box">
              <el-pagination
                background
                ref="pagination"
                @current-change="handleCurrentChangeSource"
                :current-page="tableDataSource.current_page | number"
                :page-size="tableDataSource.per_page | number"
                layout="total, prev, pager, next, jumper"
                :total="tableDataSource.total | number"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="新建专辑"
      custom-class="k-dialog--small"
      :close-on-click-modal="false"
      :visible.sync="addAlbumVisible"
    >
      <el-form :model="addAlbum" ref="addAlbum" :rules="rules.addAlbum" label-width="95px">
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="addAlbum.name" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="备注(非必填)" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 3}"
            placeholder="请输入备注"
            v-model="addAlbum.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="handelAlbumAdd">确 定</el-button>
        <el-button @click="addAlbumVisible = false" :size="size">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑专辑"
      custom-class="k-dialog--small"
      :close-on-click-modal="false"
      :visible.sync="editAlbumVisible"
    >
      <el-form :model="editAlbum" ref="editAlbum" :rules="rules.editAlbum" label-width="95px">
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="editAlbum.name" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="备注(非必填)" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 3}"
            placeholder="请输入备注"
            v-model="editAlbum.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="handelAlbumEdit('editAlbum')">确 定</el-button>
        <el-button @click="editAlbumVisible = false" :size="size">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新建文件夹"
      custom-class="k-dialog--small"
      :close-on-click-modal="false"
      :visible.sync="addFolderVisible"
    >
      <el-form :model="addFolder" ref="addFolder" :rules="rules.addFolder" label-width="95px">
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="addFolder.name" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="专辑" prop="pid">
          <el-cascader
            v-model="addFolder.pid"
            :options="treeData"
            :props="cascaderProps"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="备注(非必填)" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 3}"
            placeholder="请输入备注"
            v-model="addFolder.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="handelFolderAdd">确 定</el-button>
        <el-button @click="addFolderVisible = false" :size="size">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑文件夹"
      custom-class="k-dialog--small"
      :close-on-click-modal="false"
      :visible.sync="editFolderVisible"
    >
      <el-form :model="editFolder" ref="editFolder" :rules="rules.editFolder" label-width="95px">
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="editFolder.name" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="专辑" prop="pid">
          <el-cascader
            :disabled="editFolderPid"
            v-model="editFolder.pid"
            :options="treeData"
            :props="cascaderProps"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="备注(非必填)" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 3}"
            placeholder="请输入备注"
            v-model="editFolder.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="handelFolderEdit('editFolder')">确 定</el-button>
        <el-button @click="editFolderVisible = false" :size="size">取 消</el-button>
      </span>
    </el-dialog>
    <el-drawer
      custom-class="k-drawer"
      :visible.sync="eidtFormVisiable"
      :wrapperClosable="false"
      direction="rtl"
      destroy-on-close
      size="50%"
    >
      <div class="detail_dialog">
        <div class="detail_dialog_con">
          <div class="detail_header">
            <b>文件名：</b>
            <span class="name" v-if="editName == false">{{sourceInfo.name}}</span>
            <!-- <el-form :model="editNameForm" ref="editNameForm" :rules="rules.editNameForm" :size="size" v-if="editName == true">
                    <el-form-item prop="name">
                        <el-input v-model="editNameForm.name" style="margin-top:20px;"></el-input>
                    </el-form-item>
                </el-form> 
                <a class="edit-name" v-if="editName == false" @click="editSourceName(sourceInfo.id,sourceInfo.name)"><i></i></a>
            <a class="edit-name" v-if="editName == true" @click="handleEditSourceName('editNameForm',sourceInfo.id)"><i></i></a>-->
            <i class="el-icon-close detail_dialog_close" @click="eidtFormVisiable = false"></i>
          </div>
          <div class="detail_main">
            <div class="videoimg_box" v-if="sourceInfo.type == 'video'">
              <video
                :src="sourceInfo.file"
                :poster="sourceInfo.top_img"
                controls="controls"
                preload="none"
                controlslist
                style="width: auto; height: 100%;"
              >
                <a class="btn_play"></a>
              </video>
            </div>
            <div class="videoimg_box" v-if="sourceInfo.type == 'image'">
              <img :src="sourceInfo.top_img" :alt="sourceInfo.name" />
            </div>
            <div class="detail_operate flex">
              <div>
                <a class="btn-action btn-edit" @click="editSource(sourceInfo.id)">编辑</a>
                <a class="btn-action" @click="delSource(sourceInfo.id)">删除</a>
              </div>
            </div>
          </div>
          <div class="detail_sub">
            <h3>素材信息</h3>
            <ul class="info_list">
              <li>
                <span class="title">素材ID</span>
                <span class="con nowrap">{{sourceInfo.id}}</span>
              </li>
              <li>
                <span class="title">创建时间</span>
                <span class="con nowrap">{{sourceInfo.create_time}}</span>
              </li>
              <li>
                <span class="title">素材尺寸</span>
                <span class="con nowrap">{{sourceInfo.width}}*{{sourceInfo.height}}</span>
              </li>
              <li v-if="sourceInfo.type == 'video'">
                <span class="title">视频时长</span>
                <span class="con nowrap">{{sourceInfo.times}}</span>
              </li>
              <li>
                <span class="title">素材大小</span>
                <span class="con nowrap">{{sourceInfo.size}}</span>
              </li>
              <li>
                <span class="title">素材备注</span>
                <span class="con nowrap">{{sourceInfo.remark ? sourceInfo.remark : '无'}}</span>
              </li>
              <li>
                <span class="title">专 辑</span>
                <span class="con nowrap">{{sourceInfo.source_collection_name}}</span>
              </li>
              <li>
                <span class="title">文件夹</span>
                <span class="con nowrap">{{sourceInfo.source_group_name}}</span>
              </li>
            </ul>
            <h3>人员信息</h3>
            <ul class="resource_list">
              <li>
                <span class="title">创意人</span>
                <span class="con">{{sourceInfo.creativityNames}}</span>
              </li>
              <li>
                <span class="title">设计师</span>
                <span class="con">{{sourceInfo.designNames}}</span>
              </li>
              <li>
                <span class="title">拍摄人员</span>
                <span class="con" :title="sourceInfo.shootNames">{{sourceInfo.shootNames}}</span>
              </li>
              <li>
                <span class="title">参演人员</span>
                <span class="con" :title="sourceInfo.actorNames">{{sourceInfo.actorNames}}</span>
              </li>
              <li>
                <span class="title">配音人员</span>
                <span class="con" :title="sourceInfo.dubNames">{{sourceInfo.dubNames}}</span>
              </li>
              <li>
                <span class="title">录屏人员</span>
                <span
                  class="con"
                  :title="sourceInfo.screenRecordingNames"
                >{{sourceInfo.screenRecordingNames}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="上传素材" :visible.sync="dialogFormVisibleUpload">
      <el-form ref="formUpload" :rules="formUploadRules" :model="formUpload" :size="size">
        <el-form-item label="媒体名称" prop="mediaId">
          <el-select
            v-model="formUpload.mediaId"
            @change="changeMedia"
            clearable
            placeholder="请选择媒体"
          >
            <el-option
              v-for="item in mediaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传账户" v-if="formUpload.mediaId" prop="advertiser_id">
          <el-select
            clearable
            filterable
            remote
            reserve-keyword
            v-model="formUpload.advertiser_id"
            placeholder="请选择账户"
            :remote-method="getAccounts"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogFormVisibleUpload = false">取 消</el-button>
        <el-button :size="size" type="primary" @click="uploadLineSource('formUpload')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="任务详情" :visible.sync="dialogFormVisibleTask">
      <el-table :data="taskData.data">
        <el-table-column property="id" label="ID" min-width="80"></el-table-column>
        <el-table-column property="task_type" label="任务类型" min-width="120"></el-table-column>
        <el-table-column property="status" label="状态" min-width="120"></el-table-column>
        <el-table-column property="total" label="总数" min-width="80"></el-table-column>
        <el-table-column property="progress" label="进度" min-width="80"></el-table-column>
        <el-table-column property="create_time" label="创建时间" min-width="150"></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="uploadList"
        :current-page="taskData.page | number"
        :page-sizes="[3,5]"
        :page-size="taskData.pagesize | number"
        layout="total, prev, pager, next, jumper"
        :total="taskData.total | number"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      taskData: {
        data: [],
        page: 1,
        total: 0,
        pagesize: 5
      },
      formUpload: {
        mediaId: '',
        advertiser_id: ''
      },
      formUploadRules: {
        mediaId: [
          {
            required: true,
            message: '请选择媒体',
            trigger: 'change'
          }
        ],
        advertiser_id: [
          {
            required: true,
            message: '请选择账户',
            trigger: 'change'
          }
        ]
      },
      mediaOptions: [],
      userOptions: [],
      dialogFormVisibleTask: false,
      dialogFormVisibleUpload: false,
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      loading: false,
      size: 'mini',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      cascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'child'
      },
      eidtFormVisiable: false,
      addGroup: '1',
      addAlbumVisible: false,
      addAlbum: {
        name: '',
        remark: '',
        pid: '0'
      },
      editAlbumVisible: false,
      editAlbum: {
        name: '',
        remark: '',
        id: ''
      },
      addFolderVisible: false,
      addFolder: {
        name: '',
        remark: '',
        pid: ''
      },
      editFolderVisible: false,
      editFolder: {
        name: '',
        remark: '',
        pid: [],
        id: ''
      },
      editFolderPid: true,
      rules: {
        addAlbum: {
          name: [
            {
              required: true,
              message: '请填写名称',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '名称长度不能超过 50 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ]
        },
        editAlbum: {
          name: [
            {
              required: true,
              message: '请填写名称',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '名称长度不能超过 50 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ]
        },
        addFolder: {
          name: [
            {
              required: true,
              message: '请填写名称',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '名称长度不能超过 50 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ],
          pid: [
            {
              required: function() {
                if (this.addFolder.pid || this.addFolder.pid.length > 0) {
                  return false
                }
                return true
              },
              message: '请选择素材目录',
              trigger: 'change'
            }
          ]
        },
        editFolder: {
          name: [
            {
              required: true,
              message: '请填写名称',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '名称长度不能超过 50 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ]
        },
        editNameForm: {
          name: [
            {
              required: true,
              message: '请填写名称',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '名称长度不能超过 50 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ]
        }
      },
      //专辑管理搜索项
      searchForm: {
        searchType: '0',
        query: '',
        id: '0',
        order: '1'
      },
      //专辑管理列表页
      tableData: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 0,
        groupList: [],
        sourceList: []
      },
      //素材管理搜索项
      searchFormSource: {
        query: ''
      },
      //素材管理列表页
      tableDataSource: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 0,
        list: []
      },
      domAdd: [],
      //素材详情
      sourceInfo: {},
      editName: false,
      editNameForm: {
        id: '',
        name: ''
      },
      tagsList: [
        {
          id: '-1',
          name: '全部专辑'
        }
      ],
      parentList: [],
      nameList: {},
      optionAll: false,
      selectNum: '0',
      pathData: []
    }
  },
  watch: {},
  computed: {},
  methods: {
    toTag: function(item) {
      if (item.id == -1) {
        this.searchForm.id = 0
      } else {
        this.searchForm.id = item.id
      }
      //面包屑
      this.breadcrumb(item.id, item.name)
      this.handleSearch(this.searchForm, 1)
    },
    breadcrumb: function(id, name) {
      if (id == -1) {
        this.tagsList = [
          {
            id: '-1',
            name: '全部专辑'
          }
        ]
      } else {
        for (let key in this.pathData) {
          if (key == id) {
            var arr = JSON.parse(JSON.stringify(this.pathData[key]))
            arr.push({
              id: id,
              name: name
            })
            this.tagsList = arr
          }
        }
      }
    },
    handleNodeClick: function(data) {
      this.addGroup = '2'
      this.searchForm.id = data.id

      //面包屑
      this.breadcrumb(data.id, data.name)
      this.handleSearch(this.searchForm, 1)
    },
    //点击列表 专辑图片
    handleFolder: function(item) {
      this.addGroup = '2'
      this.searchForm.id = item.id
      //面包屑
      this.breadcrumb(item.id, item.name)

      this.handleSearch(this.searchForm, 1)
    },
    //点击列表 文件夹
    handleChild: function(item) {
      this.addGroup = '2'
      this.searchForm.id = item.id

      //面包屑
      this.breadcrumb(item.id, item.name)

      this.handleSearch(this.searchForm, 1)
    },
    handleCurrentChange(val) {
      this.handleSearch(this.searchForm, val)
    },
    handleCurrentChangeSource: function(val) {
      this.handleSearchSource(this.searchFormSource, val)
    },
    // 生成查询参数
    makeParams: function(query) {
      var params = {}
      params['searchType'] = query.status
        ? query.status
        : this.searchForm.searchType
      params['query'] = query.query ? query.query : this.searchForm.query
      params['id'] = query.id ? query.id : this.searchForm.id
      params['order'] = query.order ? query.order : this.searchForm.order
      this.searchForm = params
      return params
    },
    //获取树形菜单
    getTreeData() {
      this.loading = true
      this.$api.assets.getGroupTree().then(res => {
        if (res.code === 0) {
          this.treeData = res.data.res
          this.pathData = res.data.path
          //树形新结构---面包屑使用

          // this.$message({
          //     showClose: true,
          //     message: '查询应用列表信息成功！',
          //     type: 'success'
          // });
        } else {
          var message = '查询应用列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    allAlbum: function() {
      this.addGroup = '1'
      this.searchForm.id = 0
      this.handleSearch(this.searchForm, 1)
      this.tagsList = [
        {
          id: '-1',
          name: '全部专辑'
        }
      ]
    },
    //新建专辑
    addAlbumOpen: function() {
      this.addAlbumVisible = true
    },
    handelAlbumAdd: function() {
      this.$refs['addAlbum'].validate(
        function(valid) {
          if (valid) {
            this.loading = true
            this.$api.assets.addGroup(this.addAlbum).then(res => {
              if (res.code === 0) {
                this.$message({
                  showClose: true,
                  message: '专辑添加成功！',
                  type: 'success'
                })
                this.addAlbumVisible = false
                this.getTreeData()
                this.handleSearch(this.searchForm, 1)
              } else {
                var message = '专辑添加失败！'
                if (res.message) {
                  message = res.message
                }
                this.$notify({
                  showClose: true,
                  message: message,
                  type: 'warning'
                })
              }
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    //编辑专辑
    editAlbumOpen: function(id) {
      this.editAlbumVisible = true
      this.$api.assets
        .getGroup({
          id: id
        })
        .then(res => {
          this.editAlbum.name = res.data.name
          this.editAlbum.remark = res.data.remark
          this.editAlbum.id = res.data.id
        })
    },
    handelAlbumEdit: function(formName) {
      this.$refs[formName].validate(
        function(valid) {
          if (!valid) {
            return false
          }
          this.$api.assets.modifyGroup(this.editAlbum).then(res => {
            if (res.code == '0') {
              this.$message({
                message: '专辑修改成功！',
                type: 'success'
              })
              this.editAlbumVisible = false
              this.getTreeData()
              this.handleSearch(this.searchForm, 1)
            } else {
              var message = '服务器数据异常！'
              if (res.message) {
                message = res.body.message
              }
              this.$notify({
                title: '警 告',
                message: message,
                type: 'warning'
              })
            }
          })
        }.bind(this)
      )
    },
    //新建文件夹
    addFolderOpen: function() {
      this.addFolder.name = ''
      this.addFolder.pid = ''
      this.addFolderVisible = true
      this.$nextTick(() => {
        this.$refs['addFolder'].clearValidate()
      })
    },
    handelFolderAdd: function() {
      this.$refs['addFolder'].validate(
        function(valid) {
          if (valid) {
            this.loading = true

            if (this.addFolder.pid.length > 0) {
              this.addFolder.pid = this.addFolder.pid[
                this.addFolder.pid.length - 1
              ]
            } else {
              this.addFolder.pid = ''
            }
            this.$api.assets.addGroup(this.addFolder).then(res => {
              if (res.code === 0) {
                this.$message({
                  showClose: true,
                  message: '文件夹添加成功！',
                  type: 'success'
                })
                this.addFolderVisible = false
                this.getTreeData()
                this.handleSearch(this.searchForm, 1)
              } else {
                var message = '文件夹添加失败！'
                if (res.message) {
                  message = res.message
                }
                this.$notify({
                  showClose: true,
                  message: message,
                  type: 'warning'
                })
              }
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    //编辑文件夹
    editFolderOpen: function(id) {
      this.editFolderVisible = true
      this.$api.assets
        .getGroup({
          id: id
        })
        .then(res => {
          this.editFolder.name = res.data.name
          this.editFolder.remark = res.data.remark
          this.editFolder.pid = res.data.path
          this.editFolder.id = res.data.id
        })
    },
    handelFolderEdit: function(formName) {
      this.$refs[formName].validate(
        function(valid) {
          if (!valid) {
            return false
          }
          this.$api.assets.modifyGroup(this.editFolder).then(res => {
            if (res.code == '0') {
              this.$message({
                message: '文件夹修改成功！',
                type: 'success'
              })
              this.editFolderVisible = false
              this.getTreeData()
              this.handleSearch(this.searchForm, 1)
            } else {
              var message = '服务器数据异常！'
              if (res.message) {
                message = res.body.message
              }
              this.$notify({
                title: '警 告',
                message: message,
                type: 'warning'
              })
            }
          })
        }.bind(this)
      )
    },
    //删除文件夹
    delFolder: function(id, sourceTotal) {
      this.$confirm(
        '该文件夹内包含' + sourceTotal + '条素材信息，您确定要全部删除吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$api.assets
            .delGroup({
              id: id
            })
            .then(res => {
              if (res.code === 0) {
                this.sourceInfo = res.data
                this.handleSearch(this.searchForm, 1)
                this.$message({
                  type: 'success',
                  message: '文件夹删除成功!'
                })
              } else {
                var message = '文件夹删除失败！'
                if (res.message) {
                  message = res.message
                }
                this.$message({
                  showClose: true,
                  message: message,
                  type: 'error'
                })
              }
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //专辑管理
    handleSearch: function(params, page, pageSize) {
      this.loading = true

      var param = Object.assign({}, params)

      param['page'] = page ? page : 1
      param['pageSize'] = pageSize ? pageSize : '20'

      this.$api.assets.getGroupList(param).then(res => {
        if (res.code === 0) {
          this.tableData.groupList = res.data.data.groupList
          this.tableData.sourceList = res.data.data.sourceList
          this.tableData.total = res.data.data.total
          // this.$message({
          //     showClose: true,
          //     message: '查询应用列表信息成功！',
          //     type: 'success'
          // });
        } else {
          var message = '查询应用列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    // 执行查询
    doSearch: function(event) {
      this.searchForm.id = ''
      var query = this.searchForm
      query['_t'] = Date.parse(new Date())
      this.handleSearch(this.searchForm, 1)
    },
    doSearchSource: function(event) {
      var query = this.searchFormSource
      query['_t'] = Date.parse(new Date())
      this.handleSearchSource(this.searchFormSource, 1)
    },
    //素材管理
    handleSearchSource: function(params, page, pageSize) {
      this.loading = true

      var param = Object.assign({}, params)

      param['page'] = page ? page : 1
      param['pageSize'] = pageSize ? pageSize : '20'
      this.$api.assets.getSourceList(param).then(res => {
        if (res.code === 0) {
          this.tableDataSource.list = res.data.data.list
          this.tableDataSource.total = res.data.data.total
          // this.$message({
          //     showClose: true,
          //     message: '查询素材列表信息成功！',
          //     type: 'success'
          // });
        } else {
          var message = '查询素材列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    //跳转页面
    activeUrl: function() {
      if (this.$route.query.activeName != null) {
        this.activeName = this.$route.query.activeName
      }
    },
    uploadSource: function() {
      this.$router.replace('/upload')
    },
    //批量操作
    handleAll: function() {
      this.activeName = 'second'
      this.optionAll = true
      //   console.log(this.optionAll);
    },
    handelOption: function() {
      this.optionAll = !this.optionAll
    },
    //全选
    selectAll: function(value) {
      var data = this.tableDataSource.list
      var i = 0
      data.forEach(function(v) {
        v.check = value
        i++
      })
      if (value) {
        this.selectNum = i
      } else {
        this.selectNum = 0
      }
    },
    // 点击选择
    selectChange: function() {
      var data = this.tableDataSource.list
      var i = 0
      data.forEach(function(v) {
        if (v.check == true) {
          i++
        }
      })
      this.selectNum = i
    },
    changeCard: function(item) {
      var index = this.tableDataSource.list.indexOf(item)
      //   console.log(index,item.check);
      if (item.check) {
        this.tableDataSource.list[index].check = true
      } else {
        this.tableDataSource.list[index].check = false
      }
      this.selectChange()
    },

    uploadList: function(page) {
      this.$api.get(
        'media/taskList',
        {
          page: page ? page : this.taskData.page,
          pagesize: this.taskData.pagesize
        },
        result => {
          if (result.code == 0) {
            this.dialogFormVisibleTask = true
            this.taskData = result.data
          } else {
            this.$message({
              type: 'error',
              message: result.message
            })
          }
        }
      )
    },
    uploadLineSource: function(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var data = this.tableDataSource.list
          var ids = []
          data.forEach(function(v) {
            if (v.check == true) {
              ids.push(v.id)
            }
          })
          this.$api.post(
            'media/uploadTaskAdd',
            {
              mediaId: this.formUpload.mediaId,
              advertiser_id: this.formUpload.advertiser_id,
              sourceIds: ids
            },
            res => {
              if (res.code == 0) {
                this.dialogFormVisibleUpload = false
                this.$message({
                  type: 'success',
                  duration: 3000,
                  message: '素材投放任务创建成功，等待投放进度完成!'
                })
                setTimeout(() => {
                  this.$api.get(
                    'media/taskList',
                    {
                      id: res.data,
                      page: this.taskData.page,
                      pagesize: this.taskData.pagesize
                    },
                    result => {
                      if (result.code == 0) {
                        this.dialogFormVisibleTask = true
                        this.taskData = result.data
                      } else {
                        this.$message({
                          type: 'error',
                          message: result.message
                        })
                      }
                    }
                  )
                }, 3000)
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            }
          )
        }
      })
    },
    uploadLine: function() {
      this.$api.get('media/mediaBliBli', {}, res => {
        this.mediaOptions = res
        this.dialogFormVisibleUpload = true
      })
    },
    changeMedia: function(val) {
      this.getAccounts()
    },
    getAccounts: function(query) {
      var que = {
        mediaId: this.formUpload.mediaId
      }
      if (query) {
        que['query'] = query
      }

      this.$api.get('release/getUserAccountIdList', que, res => {
        if (res.code == 0) {
          this.userOptions = res.data
        }
      })
    },
    //批量删除
    delSelectAll: function() {
      var data = this.tableDataSource.list
      var ids = []
      data.forEach(function(v) {
        if (v.check == true) {
          ids.push(v.id)
        }
      })
      this.$confirm('您确定要删除该素材吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.assets
            .delSource({
              sourceId: ids
            })
            .then(res => {
              if (res.code === 0) {
                this.optionAll = false
                this.handleSearchSource(this.searchFormSource, 1)
                this.$message({
                  type: 'success',
                  message: '素材删除成功!'
                })
              } else {
                var message = '素材删除失败！'
                if (res.message) {
                  message = res.message
                }
                this.$message({
                  showClose: true,
                  message: message,
                  type: 'error'
                })
              }
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //完成
    selectOk: function() {
      var data = this.tableDataSource.list
      var i = 0
      data.forEach(function(v) {
        v.check = false
        i++
      })
      this.optionAll = false
    },
    //素材详情
    sourceDetail: function(id) {
      this.eidtFormVisiable = true
      this.loading = true
      this.$api.assets
        .getSourceDetail({
          sourceId: id
        })
        .then(res => {
          if (res.code === 0) {
            this.sourceInfo = res.data
          } else {
            var message = '素材详情查询失败！'
            if (res.message) {
              message = res.message
            }
            this.$message({
              showClose: true,
              message: message,
              type: 'error'
            })
          }
          this.loading = false
        })
    },
    //编辑文件名
    editSourceName: function(id, name) {
      this.editName = true
      this.editNameForm.name = name
    },
    handleEditSourceName: function(formName, id) {
      this.$refs[formName].validate(
        function(valid) {
          if (!valid) {
            return false
          }
          this.editNameForm.id = id
        }.bind(this)
      )
    },
    //编辑素材
    editSource: function(id) {
      this.$router.replace('/editSource?sourceId=' + id)
    },
    //删除单个素材
    delSource: function(id) {
      var ids = []
      ids.push(id)
      this.$confirm('您确定要删除该素材吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.assets
            .delSource({
              sourceId: ids
            })
            .then(res => {
              if (res.code === 0) {
                this.eidtFormVisiable = false
                this.sourceInfo = res.data
                this.handleSearch(this.searchForm, 1)
                this.$message({
                  type: 'success',
                  message: '素材删除成功!'
                })
              } else {
                var message = '素材删除失败！'
                if (res.message) {
                  message = res.message
                }
                this.$message({
                  showClose: true,
                  message: message,
                  type: 'error'
                })
              }
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //排序
    sortSource: function() {
      this.handleSearch(this.searchForm, 1)
    },
    //切换素材管理
    typeCheck: function() {
      if (this.activeName == 'second') {
        this.handleSearchSource(this.searchFormSource, 1)
      }
    }
  },
  mounted: function() {
    var params = this.makeParams(this.$route.query)
    this.activeUrl()
    this.handleSearch(this.searchForm, 1)
    this.getTreeData()
    this.handleSearchSource(this.searchFormSource, 1)
  },
  beforeRouteUpdate: function(to, from, next) {
    var params = this.makeParams(to.query)
    this.handleSearch(this.searchForm, 1)
    this.handleSearchSource(this.searchFormSource, 1)
    this.getTreeData()
    next()
  }
}
</script>
<style lang="scss" scoped>
.k-group-check .el-form-item {
  margin-bottom: 5px;
  border-bottom: 1px solid #e8eaec;
}

.k-group-check .el-form-item:last-child {
  border-bottom: none;
}

.k-group-check .el-form-item__label {
  width: 100% !important;
  text-align: left;
}

.k-group-check .el-form-item__content {
  margin-left: 0 !important;
}

.k-dialog--small.el-dialog {
  width: 560px;
  border-radius: 2px;
}
</style>
